var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPending({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66249 11.1462C2.87318 11.1462 3.04397 10.9733 3.04397 10.7601C3.04397 10.5469 2.87318 10.374 2.66249 10.374C2.4518 10.374 2.28101 10.5469 2.28101 10.7601C2.28101 10.9733 2.4518 11.1462 2.66249 11.1462Z",
    fill: "#FFB018"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.23077 8.65044C1.48726 8.65044 1.69519 8.44002 1.69519 8.18045C1.69519 7.92087 1.48726 7.71045 1.23077 7.71045C0.974283 7.71045 0.766357 7.92087 0.766357 8.18045C0.766357 8.44002 0.974283 8.65044 1.23077 8.65044Z",
    fill: "#54B8FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.23071 5.73541C1.52384 5.73541 1.76147 5.49492 1.76147 5.19827C1.76147 4.90162 1.52384 4.66113 1.23071 4.66113C0.93758 4.66113 0.699951 4.90162 0.699951 5.19827C0.699951 5.49492 0.93758 5.73541 1.23071 5.73541Z",
    fill: "#54B8FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.70151 3.22317C3.03433 3.22317 3.30414 2.95012 3.30414 2.61329C3.30414 2.27647 3.03433 2.00342 2.70151 2.00342C2.36868 2.00342 2.09888 2.27647 2.09888 2.61329C2.09888 2.95012 2.36868 3.22317 2.70151 3.22317Z",
    fill: "#54B8FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25579 1.82458C5.63747 1.82458 5.94688 1.51145 5.94688 1.12518C5.94688 0.738913 5.63747 0.425781 5.25579 0.425781C4.87411 0.425781 4.5647 0.738913 4.5647 1.12518C4.5647 1.51145 4.87411 1.82458 5.25579 1.82458Z",
    fill: "#54B8FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.20232 1.9196C8.63591 1.9196 8.9874 1.56388 8.9874 1.12508C8.9874 0.686284 8.63591 0.330566 8.20232 0.330566C7.76873 0.330566 7.41724 0.686284 7.41724 1.12508C7.41724 1.56388 7.76873 1.9196 8.20232 1.9196Z",
    fill: "#54B8FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7511 3.49175C11.2305 3.49175 11.6191 3.09846 11.6191 2.61331C11.6191 2.12816 11.2305 1.73486 10.7511 1.73486C10.2717 1.73486 9.88306 2.12816 9.88306 2.61331C9.88306 3.09846 10.2717 3.49175 10.7511 3.49175Z",
    fill: "#54B8FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2275 6.11611C12.7557 6.11611 13.1839 5.68274 13.1839 5.14814C13.1839 4.61355 12.7557 4.18018 12.2275 4.18018C11.6992 4.18018 11.271 4.61355 11.271 5.14814C11.271 5.68274 11.6992 6.11611 12.2275 6.11611Z",
    fill: "#54B8FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2274 9.26615C12.8197 9.26615 13.2999 8.78017 13.2999 8.18068C13.2999 7.58119 12.8197 7.09521 12.2274 7.09521C11.635 7.09521 11.1548 7.58119 11.1548 8.18068C11.1548 8.78017 11.635 9.26615 12.2274 9.26615Z",
    fill: "#54B8FF"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M10.751 11.9408C11.3953 11.9408 11.9176 11.4122 11.9176 10.7602C11.9176 10.1082 11.3953 9.57959 10.751 9.57959C10.1068 9.57959 9.58447 10.1082 9.58447 10.7602C9.58447 11.4122 10.1068 11.9408 10.751 11.9408Z",
    fill: "#54B8FF"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M8.20235 13.5522C8.91074 13.5522 9.48501 12.971 9.48501 12.2541C9.48501 11.5372 8.91074 10.9561 8.20235 10.9561C7.49395 10.9561 6.91968 11.5372 6.91968 12.2541C6.91968 12.971 7.49395 13.5522 8.20235 13.5522Z",
    fill: "#54B8FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25546 13.6695C6.02798 13.6695 6.65423 13.0358 6.65423 12.254C6.65423 11.4722 6.02798 10.8384 5.25546 10.8384C4.48294 10.8384 3.85669 11.4722 3.85669 12.254C3.85669 13.0358 4.48294 13.6695 5.25546 13.6695Z",
    fill: "#54B8FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/pending.1b122545b84c3b151c6a50d855b8676e.svg";
export { ForwardRef as ReactComponent };